import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { PermissionValidationSchema } from '@/features/permissions/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCreateEstablishmentPermissionProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useCreateEstablishmentPermission = ({ onSuccess, onError }: UseCreateEstablishmentPermissionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createEstablishmentPermission'],
    mutationFn: (form: PermissionValidationSchema) => {
      const parsedProperties = form.properties && JSON.parse(form.properties?.replace(/'/g, '"'));

      const permission = {
        ...form,
        operation_klass: form.operation_klass.value,
        properties: parsedProperties
      }

      return privateAxios.post('/establishment/permissions', permission)
    },
    onSuccess,
    onError,
  })
}

export default useCreateEstablishmentPermission
